<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      v-if="isLoggin"
      v-show="!isDesconto"
      fixed
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              :to="{name:child.link}"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" 
              :to="{name:item.link}">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="white"
      class="toolbar-titlew"
      v-bind:class="[scrolled||isLoggin ? 'toolbar-shrink' : '']"
      dark
      app
      center
      fixed
    >
      <!-- <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="isLoggin"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down" @click.stop="home()" style="cursor: pointer;">Clube de Benefícios</span>
      </v-toolbar-title>
      <v-text-field
        flat
        solo-inverted
        prepend-icon="search"
        label="Search"
        class="hidden-sm-and-down"
        v-if="isLoggin"
      ></v-text-field>-->
      <v-spacer></v-spacer> 
      <v-btn 
      color="transparent"
      class="btn-menu"
        v-if="!isLoggin">
        <span @click.stop="home()"  style="cursor: pointer;">INÍCIO</span>
      </v-btn>
      <v-btn 
      color="transparent"
      class="btn-menu"
        v-if="!isLoggin">
        <span @click.stop="historia()"  style="cursor: pointer;">HISTÓRIA</span>
      </v-btn>
      <!-- <v-btn
      color="transparent"
      class="btn-menu"
        v-if="!isLoggin">
        <span @click.stop="encontro()"  style="cursor: pointer;">III ENCONTRO BIENAL</span>
      </v-btn> -->
      <v-btn
      color="transparent"
      class="btn-menu"
        v-if="!isLoggin">
        <span @click.stop="galeria()" style="cursor: pointer;">GALERIA DE FOTOS</span>
      </v-btn>
      <v-btn
        color="transparent"
      class="btn-menu"
        v-if="!isLoggin"
        >
        <span @click.stop="arvore()" style="cursor: pointer;">ÁRVORE GENEALÓGICA</span>
      </v-btn>
      <v-btn
        color="transparent"
      class="btn-menu"
        v-if="isLoggin">
        <span @click.stop="logout" style="cursor: pointer;">Sair</span>
      </v-btn>
      
      <v-spacer></v-spacer> 
      
    </v-toolbar>
    <v-content 
      v-bind:class="[!isLoggin||isDesconto ? 'content-main' : '']">
      <!--v-layout row v-if="error">
        <v-flex xs12 sm6 offset-sm3>
          <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-flex>
      </v-layout-->
      <router-view ></router-view>
    </v-content>
    
    <v-dialog v-model="error" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Erro</v-card-title>
        <v-card-text >{{error}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat
            @click.native="errorTest();"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-footer v-show="!isLoggin">
      <v-layout row wrap align-center>
        <v-flex xs12 class="barcode blue-grey">
          <!--div class="white--text ml-3">
            Made with
            <v-icon class="red--text">favorite</v-icon>
            by <a class="white--text" href="https://vuetifyjs.com" target="_blank">Vuetify</a>
            and <a class="white--text" href="https://github.com/vwxyzjn">Costa Huang</a>
          </div-->
        </v-flex>
        <v-flex xs12 class="white footer toolbar-titlew">
          <v-spacer></v-spacer> 
          <v-btn 
          color="transparent"
          class="btn-menu"
            v-if="!isLoggin">
            <span @click.stop="home()" style="cursor: pointer;">INÍCIO</span>
          </v-btn>
          <v-btn 
          color="transparent"
          class="btn-menu"
            v-if="!isLoggin">
            <span @click.stop="historia()" style="cursor: pointer;">HISTÓRIA</span>
          </v-btn>
          <v-btn
          color="transparent"
          class="btn-menu"
            v-if="!isLoggin">
            <span @click.stop="encontro()" style="cursor: pointer;">III ENCONTRO BIENAL</span>
          </v-btn>
          <v-btn
          color="transparent"
          class="btn-menu"
            v-if="!isLoggin">
            <span @click.stop="galeria()" style="cursor: pointer;">GALERIA DE FOTOS</span>
          </v-btn>
          <v-btn
            color="transparent"
          class="btn-menu"
            v-if="!isLoggin"
            >
            <span @click.stop="arvore()" style="cursor: pointer;">ÁRVORE GENEALÓGICA</span>
          </v-btn>
          <v-btn
            color="transparent"
          class="btn-menu"
            v-if="isLoggin">
            <span @click.stop="logout" style="cursor: pointer;">Sair</span>
          </v-btn>
          
          <v-spacer></v-spacer> 
          
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import AppAlert from './components/shared/AppAlert';
import usuario from "@/services/usuario";

export default {
  components: {
    AppAlert
  },
  data () {
    return {
      drawer: null,
      title: 'Vuetify.js',
      scrolled: false,
      dialogError: false
    }
  },
  methods: {
    async submit(formData) {
      await this.$store.dispatch("signUserIn", {
        username: formData.name,
        password: formData.password
      });
      await this.$router.push("/descontos");
    },
    errorTest () {
      this.dialogError = false;
      this.$store.dispatch('clearError')
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    home () {
      this.$router.push('/')
    },
    historia () {
      this.$router.push('/historia')
    },
    encontro () {
      this.$router.push('/');
      this.scrollMeTo("encontro");
    },
    galeria () {
      this.$router.push('/galeria')
    },
    arvore () {
      this.$router.push('/arvore')
    },
    logout () {
      this.$router.push('/logout')
    },
    handleScroll () {
      if (this.$store.getters.user) {
        this.scrolled = true;
      } else {
        this.scrolled = window.scrollY > 0;
      }
    },
    scrollMeTo(refName) {
      /*var element = this.$refs[refName];
      console.log(element);
      var top = element.offsetTop;
      window.scrollTo(0, top);*/
      var container = document.body;
      var element = document.getElementById(refName);
      element.scrollIntoView();
      //console.log(element.offset().top);
      
      //window.scrollTo(0, element.offsetTop);
      //container.scrollTop = element.offsetTop;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    
    error () {
      if (this.$store.getters.error) {
        this.dialogError = true;
      } else {
        this.dialogError = false;
      }
      return this.$store.getters.error
    },
    isLoggin () {
      return this.$store.getters.user?true:false;
    },
    isDesconto () {
      console.log(this.$store.getters.desconto);
      return this.$store.getters.desconto;
    },
    isUser () {
      if (!this.$store.getters.user) {
        return false;
      } else {
        usuario.getUsuario(this.$store.getters.user._id).then(res => {
          if (res != null && res.grand == "User") {
            return false;
          } else {
            return true;
          }
        });
      }
      
    },
    items () {
      let items = [
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Configurações",
          modelConf: false,
          children: [
            {
              icon: "perm_contact_calendar",
              text: "Usuários",
              link: "Usuarios"
            },
            { icon: "book", text: "Historia", link: "Params" },
            { icon: "insert_photo", text: "Galeria", link: "GaleriaParam" },
            { icon: "book", text: "Inscrições", link: "Contatos" }
          ]
        }
      ];
      return items;
    },
    menus () {
      let menus = [
        {
          icon: 'home',
          title: 'Registrar',
          to: '/signup'
        },
        {
          icon: 'label',
          title: 'Entrar',
          to: '/signin'
        }]
      if (this.$store.getters.user) {
        menus = [
          
          {
            icon: 'label',
            title: 'Logout',
            to: '/logout'
          }
        ]
      }
      return menus
    }
  }
}
</script>
<style>


  @font-face {
    font-family: TrajanPro-Bold;
    src: url("/static/fonts/TrajanPro-Bold.otf") format("opentype");
  }

  @font-face {
    font-family: TrajanPro-Regular;
    src: url("/static/fonts/TrajanPro-Regular.otf") format("opentype");
  }

  @font-face {
    font-family: TrajanPro3-Bold;
    src: url("/static/fonts/TrajanPro3-Bold.otf") format("opentype");
  }

  @font-face {
    font-family: TrajanPro3-Regular;
    src: url("/static/fonts/TrajanPro3-Regular.otf") format("opentype");
  }
  @font-face {
    font-family: marguerite;
    src: url("/static/fonts/marguerite.ttf") format("opentype");
  }
  .v-content__wrap {
    background-color: white !important;
  }
  .content-main {
    padding: 0 !important;
  }
  .btn-menu {
    box-shadow: none !important;
  }
  .btn-menu span {
    color: #a56d30;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .toolbar-titlew {
    height: 55px;
    text-align: center;
    border-image: url('/static/img/Ativo 11@4x.png') 30 round;
    border-bottom: 5px solid transparent !important;
  }
  /*.toolbar-shrink {
    background-color: #00a99d !important;
  }*/
  .v-btn__content {
    white-space: normal !important;
  }
  .barcode {
    height: 20px;
  }
  .footer {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue